import {Component, ViewEncapsulation} from '@angular/core';
import {Shared} from "../shared/shared";
import {LoginService} from "../../service/LoginService";
import {Router} from "@angular/router";

@Component({
  selector: 'app-login',
  templateUrl: 'login.html',
  styleUrls: ['login.scss'],
  encapsulation: ViewEncapsulation.None
})
export class Login {

  email: string;
  password: string;

  isSuccess: boolean = false;
  isError: boolean = false;

  typeOfLogin = 'MANAGER';

  constructor(private loginService: LoginService ,public shared: Shared, private router: Router) {
  }

  ngOnInit() {
    if(this.router.url.indexOf('/logout')!=-1){
      this.cleanCache();
    }

    if(this.router.url.indexOf('/error')!=-1){
      this.isError = true;
    }

    console.log(this.router.url);
    if(this.router.url.indexOf('/loginManager')!=-1){
      this.typeOfLogin = 'MANAGER';
    }else if(this.router.url.indexOf('/loginTutor')!=-1){
      this.typeOfLogin = 'TUTOR';
    }else if(this.router.url.indexOf('/loginProfessor')!=-1){
      this.typeOfLogin = 'PROFESSOR';
    }
  }

  loginManager(){
    this.cleanCache();
    this.loginService.loginManager(this.email, this.password).subscribe(x=>{
      if(x!=null){
          this.shared.afterLogin(x.corpId, x.id, x.token, x.type);
      }
    },error => {
      if(error == '401' || error == '403' || error == '400'){
        this.isError = true;
      }
    });
  }

  loginTutor(){
    this.cleanCache();
    this.loginService.loginTutor(this.email, this.password).subscribe(x=>{
      if(x!=null){
        this.shared.afterLogin(x.corpId, x.id, x.token, x.type);
      }
    },error => {
      if(error == '401' || error == '403' || error == '400'){
        this.isError = true;
      }
    });
  }

  loginProfessor(){
    this.cleanCache();
    this.loginService.loginProfessor(this.email, this.password).subscribe(x=>{
      if(x!=null){
        this.shared.afterLogin(x.corpId, x.id, x.token, x.type);
      }
    },error => {
      if(error == '401' || error == '403' || error == '400'){
        this.isError = true;
      }
    });
  }

  async myGoTo(url){
    this.shared.goTo(url);
    await this.delay(50);
    window.location.reload();
  }

  cleanCache(){
    localStorage.removeItem('CURRENT_MANAGER');
    localStorage.removeItem('CURRENT_TUTOR');
    localStorage.removeItem('CURRENT_PROFESSOR');
    localStorage.removeItem('CURRENT_CORP');
    localStorage.removeItem('CURRENT_SUBS_NUMBER');
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
